module.exports = __webpack_public_path__ + "static/favicon-96x96-1c32cff5081805801bc0ac75afb27b3d.png";